<template>
  <div>
    <div
      v-for="(question, questionIndex) in quizResponse"
      :key="questionIndex"
    >
      <div class="flex justify-between flex-nowrap pb-2 border-base-30 border-b p-4">
        <div>
          <div class="quiz__type">
            Short Answer
          </div>
          <p class="type-answer__heading" :class="{'text-base': isModalContent}">
            {{ question.questionTitle }}
          </p>
        </div>
        <div class="flex-shrink-0 pl-7">
          <aha-button
            @click="handleAddSlideToPresentation(response)"
            :submitting="response.isAddingSlide"
            :disabled="response.isDisabled || response.isAddingSlide"
            v-aha-emit-action="{ user_input: 'Short Answer' }"
            name="ai_generated_short_answer_add_button"
          >
            {{ $i18nPresenter.t('Add') }}
          </aha-button>
        </div>
      </div>
      <div class="quiz-item-correct-answer">
        <p>{{ question.correctQuizTypeAnswer }}</p>
      </div>
      <ul class="quiz-item__other-answers">
        <p
          class="text-base-80 border-t border-base-30 pt-4 text-sm"
          v-if="question.otherCorrectQuiz && question.otherCorrectQuiz.length"
        >
          {{ $i18nPresenter.t('Alternative answers:') }}
        </p>
        <div class="quiz-item__other-answers-list">
          <li
            v-for="otherCorrectQuiz in question.otherCorrectQuiz"
            :key="otherCorrectQuiz.index"
            class="quiz-item__other-answer"
          >
            <p class="text-base-50 pr-2">
              •
            </p>
            <p class="text-sm">
              {{ otherCorrectQuiz.title }}
            </p>
          </li>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    response: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: null,
    },
    isModalContent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    quizResponse() {
      return this.response.data || this.response.content.data
    },
  },
  methods: {
    handleAddSlideToPresentation(response) {
      this.$emit('handleAddSlideToPresentation', response)
    },
  },
}
</script>

<style lang="scss">
.quiz__type {
  background-color: #EFF1F7; // secondary-15
  width: max-content;
  font-size: 12px;
  border-radius: 20px;
  padding: 0 0.5rem;
  color: #3F4557; // secondary-60
  margin-bottom: 0.5rem;
}

.quiz-item__other-answers {
  display: block;
  padding: 0 1rem 1rem 1rem;
  list-style: none !important;
  .quiz-item__other-answers-list {
    display: flex;
    padding-right: 0;
    margin-right: 0;
  }
  .quiz-item__other-answer {
    @apply text-sm mt-1;
    display: flex;
    width: 50%;
    padding: 0 2.25rem 1rem 0;
  }
}

.quiz-item-correct-answer {
  @apply text-sm;
  padding: 1rem 2.25rem 1rem 1rem;
}

.type-answer__heading {
  @apply font-bold text-sm;
}
</style>
